import React, { useState } from 'react'
import { Stack, Typography } from '@mui/material'
import { LoadingButton } from '@mui/lab'
import * as S from './styles'
import { Container, PasswordInputField } from '../../ui'
import { Formik, Form } from 'formik'
import useSignup, { initialValues, validate } from './ResetPassword.State'
import { Box } from '@mui/system'
import { Navigate } from 'react-router-dom'

const ResetPassword: React.FC = () => {
  const { state, setState, onSubmit, invalidURL } = useSignup()
  const [disabled, setDisabled] = useState(true)

  if (invalidURL) {
    return <Navigate to="/login" replace />
  }
  return !state.success ? (
    <Formik
      initialValues={initialValues}
      validate={(values) => {
        const { errors, bar } = validate(values)
        setState({ ...state, bar })
        if(values.confirmPassword === values.newPassword && bar.value == 100) {
          setDisabled(false)
        } else {
          setDisabled(true)
        }
        return errors
      }}
      onSubmit={onSubmit}
    >
      {({ submitForm, isSubmitting }) => (
        <Form>
          <Container title="Reset your password" error={state.error}>
            <Stack spacing={3}>
              <Typography variant="body2">Please enter your new password down below.</Typography>
              <Box>
                <PasswordInputField state={{ strengthColor: state.bar.strengthColor, value: state.bar.value }} />
                <S.PasswordHelper variant="subtitle2">
                  Your password should have at least 8 characters, one uppercase, one lowercase, one number and one
                  special character
                </S.PasswordHelper>
              </Box>
              <LoadingButton
                variant="contained"
                size="large"
                disabled={disabled}
                // disabled={!(dirty && isValid)}
                loading={isSubmitting}
                onClick={submitForm}
                fullWidth
                sx={{ color: 'white' }}
              >
                Reset password
              </LoadingButton>
            </Stack>
          </Container>
        </Form>
      )}
    </Formik>
  ) : (
    <></>
    // <VerifyEmail email={state.success} />
  )
}

export default ResetPassword
